// Utils
import { enterFullscreen, exitFullscreen } from '../../utils/browserUtils';
import { sendAmplitudeEvent } from '../../analytics/amplitudeService';

// Constants
import {
    PRESENTATION_MODE_START,
    PRESENTATION_MODE_END,
    PRESENTATION_MODE_SETTINGS_UPDATE,
    FOCUS_MODE_START,
    FOCUS_MODE_END,
} from './presentationConstants';
import { EVENT_TYPE_NAMES } from '../../../common/analytics/amplitudeEventTypesUtil';

export const startPresentationMode =
    ({ hideComments, disableEditing, isFocusModeAllowed }) =>
    async (dispatch) => {
        dispatch({
            type: PRESENTATION_MODE_START,
        });
        dispatch(
            updatePresentationModeSettings({
                type: PRESENTATION_MODE_SETTINGS_UPDATE,
                hideComments,
                disableEditing,
                isFocusModeAllowed,
            }),
        );
        enterFullscreen();
        sendAmplitudeEvent({
            eventType: EVENT_TYPE_NAMES.ENTERED_PRESENTATION_MODE,
        });
    };

export const updatePresentationModeSettings =
    ({ hideComments, disableEditing, isFocusModeAllowed }) =>
    async (dispatch) => {
        dispatch({
            type: PRESENTATION_MODE_SETTINGS_UPDATE,
            hideComments,
            disableEditing,
            isFocusModeAllowed,
        });
        if (hideComments) {
            sendAmplitudeEvent({
                eventType: EVENT_TYPE_NAMES.PRESENTATION_MODE_HIDE_COMMENTS_ENABLED,
            });
        }

        if (disableEditing) {
            sendAmplitudeEvent({
                eventType: EVENT_TYPE_NAMES.PRESENTATION_MODE_PREVENT_EDITING_ENABLED,
            });
        }
    };

export const endPresentationMode = () => async (dispatch) => {
    dispatch({
        type: PRESENTATION_MODE_END,
    });
    exitFullscreen();
};

export const focusElementStart = (elementId, initialZoomScale, elementProps) => ({
    type: FOCUS_MODE_START,
    elementId,
    initialZoomScale,
    elementProps,
});

export const focusElementEnd = () => ({ type: FOCUS_MODE_END });
